// extracted by mini-css-extract-plugin
var _1 = "EditorAbsolute_fillMode__b9de9";
var _2 = "EditorAbsolute_root__59f1f";
export { _1 as "fillMode", _2 as "root" }
